<template>
    <div id="rutas-list">
        <div class="section-header d-flex mx-4">
        <!-- <b-alert show class="section-header d-flex mx-1"> -->
            <h3 class="my-2"> {{ listaNum }} Rutas encontradas </h3>
            <div class="select-view ml-auto" style="font-size: 3rem;">
                <b-icon-grid class="border rounded p-2" @click="vista='G'"></b-icon-grid>
                <b-icon-view-stacked class="border rounded p-2" @click="vista='L'"></b-icon-view-stacked>
            </div>
        <!-- </b-alert> -->
        </div>

        <div class="row mx-1">
            <aside class="col-xs-12 col-md-6 col-lg-3 mb-3 left-sidebar">
                <div class="card">
                    <div class="card-body">
                        <div class="card-body-title">
                            <h5 class="widget-title">Buscar Rutas</h5>
                        </div>
                        <form>

                            <div class="form-destination d-flex align-items-center">
                                <!-- <img class="pr-3" src="/img/map-marker-icon.svg" alt=""> -->
                                <div class="form-group">
                                    <label class="text-small" for="selectDestination">Destino</label>
                                    <!-- <b-form-select v-model="destino" @change="filtraHoteles"                                     -->
                                    <b-form-select v-model="destino"
                                        :options="destinos"
                                        class="mb-1"
                                    ></b-form-select>
                                </div>
                            </div>
                            <!-- <div class="form-button text-center">
                                <b-btn disabled type="submit" variant="primary" class="ml-2">BUSCAR
                                    <i class="fa fa-search"></i>
                                </b-btn>
                            </div> -->
                        </form>
                    </div>
                </div>
            </aside>

            <!-- Resultados -->
            <div v-if="vista==='G'" class="col d-flex flex-wrap">
                <div class="col-xs-12 col-lg-4"
                    v-for="item in hotelesFiltrados" :key="item.hot">
                    <hotel :item="item"></hotel>
                </div>
            </div>
            <div v-else class="col-12 col-lg-9">
                <div class="card card-hotel-large"
                    v-for="item in hotelesFiltrados" :key="item.hot">
                    <hotel :item="item"></hotel>
                </div>
            </div>
        </div>

        <!-- Modal Precios -->
        <!-- <hotelPrecios></hotelPrecios>   -->
        <!-- <confianza/> -->

    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex'; //store

import hotel from '@/components/hotel.vue'

export default {
    name: 'hoteles',
    components: {
        hotel,

    },
    data() {
        return {
            listaHoteles: [],
            listaSalidas: [],
            vista: 'G',
            destino: null,
            salida: null,
        }
    },
    computed: {
        ...mapState(['auth','datos','errores','G']),

        hotelesFiltrados() {
            var H=this.$util.object_array(this.listaHoteles);
            if (this.salida!==null) {
                H = H.filter(item => item.salidas.indexOf(this.salida) != -1);
            }
            if (this.destino!==null) {
                H = H.filter(item => item.pobla === this.destino);
            }
            return this.$util.array_object(H);
        },
        listaNum() {
            return Object.keys(this.hotelesFiltrados).length;
        },
        destinos() {
            var lista=(this.salida!==null ? this.hotelesFiltrados : this.listaHoteles);
            let result=this.$util.array_valores(lista,'pobla');
            var A=[{text:"¿A dónde quieres ir?", value:null, disabled:false}];
            result.forEach(value => {
                A.push({text:value, value:value, disabled:false});
            });
            return A;
        },
        salidas() {
            let result=this.$util.object_array(this.listaSalidas);
            var A=[{text:"Selecciona Transporte", value:null, disabled:false}];
            result.forEach(value => {
                let txt=(value=='*SIN TRANSPORTE'?'En mi vehiculo (Sin Bus)':"BUS - "+value);
                A.push({text:txt, value:value, disabled:false});
            });
            return A;
        },

    },
    methods: {
        ...mapMutations(['loading','alerta','modal']),
        ...mapActions(['exec']),

        async leemos() {
            //this.loading();
            var args={ sid: this.auth.token };
            let r=await this.$store.dispatch('exec',{api:'rutas', arg:args});
            this.leemos_back(r);
        },

        leemos_back(r) {
            if (r.error) {
                this.modal({tit: this.name, msg: r.datos});
            }
            this.listaHoteles=r.datos[0];
            this.listaSalidas=r.datos[1];

            console.log("*leemos_back",this.listaHoteles,this.listaSalidas);
        },

        async hotel_info(item) {
            this.$store.state.hoteles.hotel=item;
            this.$router.push('/hotel-info');
        },

        async hotel_precios(item) {
            await this.$store.dispatch('hotel_precios',item);
            this.$bvModal.show("modal_hotelPrecios");
        },

        imagen(hot) {
            return this.G.url_img + '?w=123|vc_agencias|hoteles_img|||' + hot;
        },

    },
    mounted() {
        this.leemos(); //leemos hoteles disponibles

    },
}
</script>
